module.exports = __webpack_public_path__ + "images/for_company_page/point2-3_cde70bb933aee3287c4cd5c97af424c3.jpg";